import { CircularProgress, Typography } from '@mui/material';
import { Center } from './Center';

interface LoaderProps {
  isLoading: boolean;
  message?: string;
  children?: React.ReactNode;
}

export const Loader = ({ isLoading, message, children }: LoaderProps) => {
  return isLoading ? (
    <Center>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '10px',
        }}
      >
        <CircularProgress color="primary" />
        {message && (
          <Typography variant="body1" color="textSecondary">
            {message}
          </Typography>
        )}
      </div>
    </Center>
  ) : (
    (children ?? <></>)
  );
};
